import React, {FC, useEffect} from 'react';
import styled, {css} from 'src/theme';
import {Card, Col, Popover, Row} from "antd";
import {InfoCircleOutlined} from '@ant-design/icons';

import {usePresenter} from "./usePresenter";

import {profileImg} from 'src/assets/images';

import {roundToHundredths} from "src/utils/math";
import {IProduct} from 'src/api';
import {RoofThickness} from "../../../types/types";

interface Props {
}

interface ICoatingHint {
  segment: string;
  rows: Array<[string, string]>;
}

const coatingHints: Record<string, ICoatingHint> = {
  'полиэстер': {
    segment: 'Стандарт',
    rows: [
      ['Полимерная основа', 'полиэфир'],
      ['Толщина покрытия', '25 мкм'],
      ['Цветостойкость', 'RUV3'],
      ['Мех. стойкость', 'удовл.'],
      ['Коррозионная стойкость', 'удовл.'],
      ['Прочность при изгибе', '1,5T'],
      ['Макс. температура', '80°C'],
      ['Гарантия', 'до 5 лет'],
    ],
  },
  'полиэстер Norman': {
    segment: 'Премьер',
    rows: [
      ['Полимерная основа', 'полиэфир'],
      ['Толщина покрытия', '25 мкм'],
      ['Цветостойкость', 'RUV3'],
      ['Мех. стойкость', 'удовл.'],
      ['Коррозионная стойкость', 'хорошая'],
      ['Прочность при изгибе', '1,5T'],
      ['Макс. температура', '100°C'],
      ['Гарантия', 'до 20 лет'],
    ],
  },
  'Norman': {
    segment: 'Премьер',
    rows: [
      ['Полимерная основа', 'полиэфир'],
      ['Толщина покрытия', '25 мкм'],
      ['Цветостойкость', 'RUV3'],
      ['Мех. стойкость', 'удовл.'],
      ['Коррозионная стойкость', 'хорошая'],
      ['Прочность при изгибе', '1,5T'],
      ['Макс. температура', '100°C'],
      ['Гарантия', 'до 20 лет'],
    ],
  },
  'Purman': {
    segment: 'Премиум',
    rows: [
      ['Полимерная основа', 'мод. полиуретан'],
      ['Толщина покрытия', '50 мкм'],
      ['Цветостойкость', 'RUV4'],
      ['Мех. стойкость', 'отличная'],
      ['Коррозионная стойкость', 'отличная'],
      ['Прочность при изгибе', '0,5T'],
      ['Макс. температура', '120°C'],
      ['Гарантия', 'до 50 лет'],
    ],
  },
  'VikingMP E': {
    segment: 'Премиум',
    rows: [
      ['Полимерная основа', 'полиуретан + полиэфир'],
      ['Толщина покрытия', '45 мкм'],
      ['Цветостойкость', 'RUV4'],
      ['Мех. стойкость', 'отличная'],
      ['Коррозионная стойкость', 'отличная'],
      ['Прочность при изгибе', '1,5T'],
      ['Макс. температура', '100°C'],
      ['Гарантия', 'до 40 лет'],
    ],
  },
  'VikingMP': {
    segment: 'Стандарт',
    rows: [
      ['Полимерная основа', 'полиэфир'],
      ['Толщина покрытия', '30 мкм'],
      ['Цветостойкость', 'RUV3'],
      ['Мех. стойкость', 'хорошая'],
      ['Коррозионная стойкость', 'хорошая'],
      ['Прочность при изгибе', '1,5T'],
      ['Макс. температура', '100°C'],
      ['Гарантия', 'до 10 лет'],
    ],
  },
  'PureTech Mat': {
    segment: 'Премьер',
    rows: [
      ['Полимерная основа', 'полиуретан'],
      ['Толщина покрытия', '35 мкм'],
      ['Цветостойкость', 'RUV4'],
      ['Мех. стойкость', 'отличная'],
      ['Коррозионная стойкость', 'отличная'],
      ['Прочность при изгибе', '0,5T'],
      ['Макс. температура', '100°C'],
      ['Гарантия', 'до 35 лет'],
    ],
  },
  'VALORI': {
    segment: 'Премьер',
    rows: [
      ['Полимерная основа', 'мод. полиэфир'],
      ['Толщина покрытия', '30 мкм'],
      ['Цветостойкость', 'RUV4'],
      ['Мех. стойкость', 'хорошая'],
      ['Коррозионная стойкость', 'отличная'],
      ['Прочность при изгибе', '1,5T'],
      ['Макс. температура', '100°C'],
      ['Гарантия', 'до 30 лет'],
    ],
  },
  'Puretan': {
    segment: 'Премьер',
    rows: [
      ['Полимерная основа', 'полиуретан'],
      ['Толщина покрытия', '35 мкм'],
      ['Цветостойкость', 'RUV4'],
      ['Мех. стойкость', 'отличная'],
      ['Коррозионная стойкость', 'отличная'],
      ['Прочность при изгибе', '0,5T'],
      ['Макс. температура', '100°C'],
      ['Гарантия', 'до 30 лет'],
    ],
  },
  'Matt MP': {
    segment: 'Премьер',
    rows: [
      ['Полимерная основа', 'полиэфир'],
      ['Толщина покрытия', '25 мкм'],
      ['Цветостойкость', 'RUV3'],
      ['Мех. стойкость', 'хорошая'],
      ['Коррозионная стойкость', 'хорошая'],
      ['Прочность при изгибе', '1,5T'],
      ['Макс. температура', '100°C'],
      ['Гарантия', 'до 20 лет'],
    ],
  },
  'SteelMatt': {
    segment: 'Эконом',
    rows: [
      ['Полимерная основа', 'полиэфир'],
      ['Толщина покрытия', '20 мкм'],
      ['Цветостойкость', 'RUV3'],
      ['Мех. стойкость', 'удовл.'],
      ['Коррозионная стойкость', 'удовл.'],
      ['Прочность при изгибе', '1,5T'],
      ['Макс. температура', '80°C'],
      ['Гарантия', 'до 5 лет'],
    ],
  },
  'Ecosteel': {
    segment: 'Премьер',
    rows: [
      ['Полимерная основа', 'мод. полиэстер'],
      ['Толщина покрытия', '30 мкм'],
      ['Цветостойкость', 'RUV3'],
      ['Мех. стойкость', 'хорошая'],
      ['Коррозионная стойкость', 'хорошая'],
      ['Прочность при изгибе', '1,5T'],
      ['Макс. температура', '80°C'],
      ['Гарантия', '—'],
    ],
  },
};

const CoatingHintContent: React.FC<{ hint: ICoatingHint }> = ({ hint }) => (
  <CoatingHintTable>
    <thead>
      <tr>
        <th colSpan={2}>{hint.segment}</th>
      </tr>
    </thead>
    <tbody>
      {hint.rows.map(([label, value]) => (
        <tr key={label}>
          <td>{label}</td>
          <td>{value}</td>
        </tr>
      ))}
    </tbody>
  </CoatingHintTable>
);

export const Step4: FC<Props> = () => {
    const presenter = usePresenter();

    const handleClickCoating = (coating: string, thickness: RoofThickness) => {
        presenter.setCoatingName(coating);
        presenter.setThicknessName(thickness);
    }

    const currentProducts = presenter.priceList
        .filter((product: IProduct) => product.offer_group === presenter.profileType)
        .filter((product: IProduct) => {
            return product.type === presenter.profileName;
        });

    useEffect(() => {
        if (currentProducts.length > 0) {
            if (!currentProducts.find(product => product.coating === presenter.selectedCoating && product.thickness === presenter.selectedThickness)) {
                presenter.setCoatingName(currentProducts[0].coating);
                presenter.setThicknessName(currentProducts[0].thickness);
            }
        }
    }, [currentProducts, presenter])

    interface ICoating {
        key: number;
        coating: string;
        img: string;
        thickness: RoofThickness;
        price: string;
        hint?: ICoatingHint;
    }

    const coatings2: ICoating[] = currentProducts.map((product, index) => {
        return {
            key: index,
            coating: product.coating,
            img: profileImg,
            thickness: product.thickness,
            price: roundToHundredths(product.price) + ' руб./' + product.unit,
            hint: coatingHints[product.coating],
        }
    });

    return (
        <RowStyled justify='center' gutter={[0, 40]}>
            <Col xs={23}>
                <HeaderStyled>Выберите вид покрытия</HeaderStyled>
                <Row gutter={[{xs: 8, lg: 16}, {xs: 8, lg: 16}]} style={{textAlign: 'center'}}>

                    {
                        coatings2.map((product) => (
                            <Col xs={8} lg={6} key={product.key}>
                                <CardWrapper>
                                    <CardStyled
                                        onClick={() => handleClickCoating(product.coating, product.thickness)}
                                        $active={product.coating === presenter.selectedCoating && product.thickness === presenter.selectedThickness}
                                        cover={
                                            <img
                                                alt={product.coating}
                                                src={product.img}
                                            />
                                        }
                                    >
                                        <Card.Meta
                                            title={product.coating}
                                            description={product.thickness + ' мм'}
                                        />
                                        {product.price}
                                    </CardStyled>
                                    {product.hint && (
                                        <HintIcon onClick={(e) => e.stopPropagation()}>
                                            <Popover
                                                content={<CoatingHintContent hint={product.hint} />}
                                                trigger="hover"
                                                placement="right"
                                            >
                                                <InfoCircleOutlined />
                                            </Popover>
                                        </HintIcon>
                                    )}
                                </CardWrapper>
                            </Col>
                        ))
                    }

                </Row>
            </Col>
        </RowStyled>
    );
};

const CardWrapper = styled.div`
  position: relative;
`;

const HintIcon = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 10;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.35);
  cursor: pointer;
  transition: color 0.2s;
  &:hover {
    color: rgba(0, 0, 0, 0.65);
  }
`;

const CoatingHintTable = styled.table`
  width: 260px;
  border-collapse: collapse;
  font-size: 12px;
  line-height: 1.4;

  thead th {
    font-weight: 700;
    font-size: 13px;
    padding: 4px 0 6px;
    color: ${props => props.theme.colors.orange};
    text-align: left;
    border-bottom: 1px solid rgba(0,0,0,0.12);
  }

  tbody td {
    padding: 3px 0;
    vertical-align: top;
    color: rgba(0, 0, 0, 0.75);
  }

  tbody td:first-child {
    width: 50%;
    color: rgba(0, 0, 0, 0.45);
    padding-right: 8px;
  }
`;

const CardStyled = styled(Card)<{ $active: boolean }>`
  ${(props) => css`
    color: ${props.theme.colors.nero};
    border-radius: 4px;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);
    border: 1px solid ${props.$active ? props.theme.colors.orange : props.theme.colors.white};
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: -0.02em;

    & .ant-card-cover {
      padding: 7px 14px;
    }

    & .ant-card-body {
      padding: 0 14px 14px;
    }

    & .ant-card-meta-detail {
      margin: 5px 0 20px;
    }

    & .ant-card-meta-title {
      margin: 0 0 3px !important;
      font-family: Montserrat, sans-serif;
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 17px;
    }

    & .ant-card-meta-description {
      font-family: PT Root UI, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 13px;
      line-height: 100%;
      letter-spacing: -0.03em;
      color: ${props.theme.colors.nero};
    }

    @media screen and ${props.theme.media.mobile} {
      & .ant-card-cover {
        padding: 5px;
      }

      & .ant-card-body {
        padding: 0 5px 5px;
      }
    }
  `}
`;

const RowStyled = styled(Row)`
  padding: 25px 10px;
  background: ${props => props.theme.colors.smoke};
  border-radius: 6px;
`;

const HeaderStyled = styled.h4`
  font-family: Montserrat, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  margin-bottom: 15px;
  color: ${props => props.theme.colors.nero};
`;
